import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logo from '../../Logo';
import Wizard from '../../Wizard/Wizard';
import ServicesDescriptionVirtualMember from './Steps/ServicesDescriptionVirtualMember';
import UserDetailsVirtualMember from './Steps/UserDetailsVirtualMember';
import PhoneStepVirtualMember from './Steps/PhoneStepVirtualMember';
import SmsStepVirtualMember from './Steps/SmsStepVirtualMember';
import Summary from './Steps/Summary';
import { updateOnboardingWizardProgress } from '../../../reducers/currentProgressOnboardingWizard';
import PaymentForm from './Steps/PaymentForm';
import { logginSuccess } from '../../../reducers/auth';
import SuspenseUntil from '../../SuspenseUntil';
import { isDealInfoLoaded } from '../../../reducers/DealInfo';
import { Map } from 'immutable';
import plans from '../../../constants/plans';
import { sendMemberShipPlan } from '../../../reducers/authVirtualMember';

const selectedPlan = {
  intro: plans.INTRO_MEMBERSHIP_PLAN.value,
  hood: plans.HOOD_MEMBERSHIP_PLAN.value,
  hoodFull: plans.HOOD_FULL_MEMBERSHIP_PLAN.value
};

class OnBoardingWizardVirtualMembers extends Component {
  constructor(props) {
    super(props);
    this.wizardRef = React.createRef();
  }
  componentDidMount() {
    const { match, sendMemberShipPlan } = this.props;
    if (match.params.plan) {
      this.wizardRef.current.updateSummary(Map().set('membershipPlan', selectedPlan[match.params.plan]));
      sendMemberShipPlan(Map().set('membershipPlan', selectedPlan[match.params.plan]));
      this.wizardRef.current.next();
    }
  }
  render() {
    const { editUserDetails, updateOnboardingWizardProgress, currentProgressOnboardingWizard } = this.props;
    const { currentPage, summary } = currentProgressOnboardingWizard;
    const { language } = this.props.lang;
    return (
      <div className="onboarding-wizard">
        <div className="onboarding-wizard__wrapper">
          <Logo text="Tel aviv" />
          <Wizard
            noBackFromStep={2}
            initialStep={currentPage}
            summary={summary}
            ref={this.wizardRef}
            onComplete={editUserDetails}
            onPrematureExit={updateOnboardingWizardProgress}
            containerClassName="onboarding-wizard__component"
            arrowClassName={`onboarding-wizard__arrow ${language.startsWith('he') ? 'onboarding-wizard__arrow--rtl' : ''}`}
            language={language}
          >
            <ServicesDescriptionVirtualMember />
            <UserDetailsVirtualMember />
            <PhoneStepVirtualMember />
            <SmsStepVirtualMember />
            <SuspenseUntil shouldSuspense={!this.props.isDealInfoLoaded}>
              <PaymentForm />
            </SuspenseUntil>
            <Summary />
          </Wizard>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentProgressOnboardingWizard: state.currentProgressOnboardingWizard,
  lang: state.lang,
  isDealInfoLoaded: isDealInfoLoaded(state)
});

const mapDispatchToProps = dispatch => ({
  sendMemberShipPlan: plan => dispatch(sendMemberShipPlan(plan)),
  updateOnboardingWizardProgress: (page, summary) => dispatch(updateOnboardingWizardProgress(page, summary)),
  login: token => dispatch(logginSuccess(token))
});
// Make a reducer in sagas for edit!!!

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnBoardingWizardVirtualMembers);



// WEBPACK FOOTER //
// ./src/components/Views/OnboardingVirtualMembers/OnBoardingWizardVirtualMember.js